import { createStore, applyMiddleware } from 'redux'
import { combineReducers } from 'redux'
import thunk from 'redux-thunk';
import auth from './redux/reducers/Auth';
import history from './redux/reducers/History';
import connectedMessageBar from './redux/reducers/ConnectedMessageBar';
import {
    Client as GraphClient,
} from "@microsoft/microsoft-graph-client";
import ApiService from "./components/ApiService";
import { MessageBarType} from "office-ui-fabric-react";
import H from "history";
import { UserAccessLevel } from './models/UserAccessRecord';
import {PublicClientApplication} from "@azure/msal-browser";
import {AccountInfo} from "@azure/msal-common";

export interface IRootState {
    auth: AuthState,
    history: H.History;
    connectedMessageBar: {
        show: boolean;
        message: string;
        messageBarType: MessageBarType;
        actions?: JSX.Element;
    }
}

export interface AuthState {
    msalInstance: PublicClientApplication;
    user?: AccountInfo;
    userIsCdbEmployee: boolean;
    usersCdbAccessLevel?: UserAccessLevel;
    graphClient: GraphClient;
    apiService: ApiService;
}

export default createStore<IRootState,any,any,any>(
    // @ts-ignore
    combineReducers({
        auth: auth,
        history: history,
        connectedMessageBar: connectedMessageBar,
    }),applyMiddleware(thunk)
);